<template>

  <div class="form form-search">
    <div class="form-group">
      <input type="text" placeholder="Enter order number" class="form-control" v-model="searchTerm" @keyup.enter="showSearchResults">
      <input type="submit" value="Search" class="form-search__button" @click="showSearchResults" />
    </div>
  </div>

</template>

<script>
export default {
  name: 'SearchOrders',
  methods: {
    showSearchResults() {
      if(typeof this.searchTerm !== 'undefined') {
        if(this.searchTerm !== '') {
          this.$router.push('/search-results/order/term/'+this.searchTerm);
        }
      }
    }
  },
  data() {
    return {
      searchTerm: this.$route.params.term
    }
  }
}
</script>
